import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFile";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { agregarPlantillaRequisito } from "../services/expediente.service";
import {
  createUploadFile,
  obtenerDocumento,
  deleteFile
} from "../services/uploadFile.service";
import { notification, Modal } from "antd";
import Loader from "./Loader";
import { getAllFormulariosPorRequisito } from "../services/requisitos.service";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
export default function AgregarPlantillasRequisitoExpediente({
  setIsVisibleModal,
  setReload,
  reload,
  id_expediente,
  requisito,
  idMov,
}) {
  const [fileSelectedext, setFileSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formularios, setFormularios] = useState([]);
  const { confirm } = Modal;
  useEffect(() => {
    loadFormularios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requisito]);

  const loadFormularios = async () => {
    setIsLoading(true);
    try {
      const result = await getAllFormulariosPorRequisito(
        requisito.id_requisito,
        requisito.id_mov
      );
      console.log("result formularios", result.data);
      setFormularios(result.data);
    } catch (error) {
      console.error("Error al cargar formularios:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const abrirDocumento = async (key) => {
    console.log("document open", key);
    try {
      const response = await obtenerDocumento(key);
      console.log("response", response);
      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?")[0];
        window.open(resultURL, "_blank");
      } else {
        console.error("Error obteniendo documento");
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  const onClose = () => {
    setIsVisibleModal(false);
  };

  const saveAction = async (uploadedFiles) => {
    if (uploadedFiles && uploadedFiles.length > 0) {
      try {
        setIsLoading(true);
        const data = {
          id_mov: idMov,
          formularios: uploadedFiles,
        };
        const result = await agregarPlantillaRequisito(data);
        if (result.data) {
          setReload(!reload);
          onClose();
        } else {
          notification.error({
            message: "Error al agregar plantillas",
            description: "No se pudo agregar la o las plantillas adjuntas.",
          });
        }
      } catch (error) {
        console.error("Error al agregar plantillas al requisito:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      notification.error({
        message: "Debe subir un documento",
        description:
          "Es necesario subir el documento solicitado para completar el requisito.",
      });
    }
  };

  const addFiles = async () => {
    try {
      setIsLoading(true);

      // Transformar los formularios antiguos para incluir datos completos
      const transformedFormularios = await Promise.all(
        formularios.map(async (formulario) => {
          // Obtener la URL válida desde `obtenerDocumento`
          try {
            const response = await obtenerDocumento(formulario.url);
            if (response.status === 200) {
              return {
                fileId: formulario.fileId || formulario.id, // Asegurar fileId
                url: response.url, // Usar la URL directamente desde obtenerDocumento
                fileName: formulario.nombre, // Nombre del archivo
                id_mov: formulario.id_mov
              };
            } else {
              console.error(
                `No se pudo obtener la URL para el formulario: ${formulario.nombre}`
              );
            }
          } catch (error) {
            console.error(
              `Error al obtener la URL del documento: ${formulario.nombre}`,
              error
            );
          }
          return null; // Retornar nulo si hay un error
        })
      );

      // Subir los nuevos archivos seleccionados
      const uploadResults = await Promise.all(
        fileSelectedext.map(async (file) => {
          const result = await createUploadFile(
            file.file,
            id_expediente,
            '', '', '', '',
            requisito.id_mov
          );
          return result.status === 200 ? result : null;
        })
      );

      // Combinar documentos antiguos y nuevos
      const combinedDocuments = [
        ...transformedFormularios.filter(Boolean), // Formularios transformados válidos
        ...uploadResults
          .filter((res) => res !== null)
          .map((res) => ({
            fileId: res.fileId?.toString(),
            url: res.url, // Usar la URL directa desde el upload
            fileName: res.fileName,
            id_mov: res.id_mov
          })),
      ];

      // Guardar los documentos combinados
      saveAction(combinedDocuments);
    } catch (error) {
      console.error("Error al procesar los archivos:", error);
      notification.error({
        message: "Error al procesar los archivos",
        description: "Ocurrió un error al intentar procesar los archivos.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteForm = async (row) => {
    if(row.id_mov){
      const response = await  deleteFile(row.fileId);
    }
    setReload(!reload)
  }

  const removeFormulario = (fileId, row) => {
    // Muestra la confirmación
    confirm({
      title: "¿Estás seguro de que deseas eliminar este formulario?",
      content: "Esta acción no se puede deshacer.",
      okText: "Sí",
      cancelText: "No",
      onOk() {
        // Si el usuario confirma, elimina el formulario
        setFormularios((prev) => prev.filter((form) => form.fileId !== fileId));
        deleteForm(row);
      },
      onCancel() {
        // Si el usuario cancela, no hace nada
        console.log("Cancelado");
      },
    });
  };

  const handleCompleteSelection = (selection) => {
    console.log("Archivo seleccionado:", selection);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Grid
            item
            xs={12}
            style={{
              marginBottom: 20,
              border: "2px solid green",
              borderRadius: "8px",
              padding: "10px",
            }}
          >
            <Grid container spacing={2}>
              {formularios.length > 0 &&
                formularios.map((row) => (
                  <Grid item xs={6} key={row.fileId}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between", // Espaciado entre nombre y el botón
                        alignItems: "center", // Alineación vertical
                        padding: "8px", // Para dar algo de separación entre el borde y los elementos
                        border: "1px solid #e0e0e0", // Agregar borde sutil alrededor de cada archivo
                        borderRadius: "8px", // Bordes redondeados para un look más suave
                        marginBottom: "8px", // Separación entre archivos
                      }}
                    >
                      <div
                        onClick={() => abrirDocumento(row.url)}
                        style={{
                          textDecoration: "none",
                          cursor: "pointer",
                          color: COLORS.PRIMARY,
                          display: "flex",
                          alignItems: "center", // Alineación en el eje vertical
                        }}
                      >
                        <DescriptionOutlinedIcon
                          style={{ fontSize: 40, marginRight: "8px" }}
                        />
                        <Typography
                          variant="body2"
                          noWrap
                          style={{ maxWidth: "200px" }}
                        >
                          {row.nombre}
                        </Typography>
                      </div>
                      {row.id_mov && (
                        <IconButton
                          color="secondary"
                          onClick={(event) => {
                            event.stopPropagation(); // Evita que el clic se propague y abra el documento
                            removeFormulario(row.fileId, row);
                          }}
                          style={{
                            padding: "8px", // Reduce el padding para hacerlo más compacto
                            fontSize: "20px", // Ajuste al tamaño del ícono
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                ))}

              {formularios.length === 0 && (
                <Grid item xs={12}>
                  <span style={{ fontWeight: "bold" }}>
                    Sin formularios activos
                  </span>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <UploadFile
              setFileSelected={setFileSelected}
              fileSelectedext={fileSelectedext}
              onCompleteFileSelection={handleCompleteSelection}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <ButtonComponent name="Guardar" toAction={addFiles} />
              <ButtonComponent
                name="Cancelar"
                toAction={onClose}
                color={COLORS.DANGER}
              />
            </Box>
          </Grid>
        </>
      )}
    </>
  );
}
